import { render, staticRenderFns } from "./AdminGroupManagement.vue?vue&type=template&id=010a9f73&scoped=true&"
import script from "./AdminGroupManagement.vue?vue&type=script&lang=ts&"
export * from "./AdminGroupManagement.vue?vue&type=script&lang=ts&"
import style0 from "./AdminGroupManagement.vue?vue&type=style&index=0&id=010a9f73&lang=scss&scoped=true&"
import style1 from "./AdminGroupManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a9f73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
